import { AlertTriangle } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useBookContentWarnings } from '@/hooks/useBookContentWarnings';

interface ContentWarningBadgeProps {
  bookId: string;
  className?: string;
}

export function ContentWarningBadge({ bookId, className = '' }: ContentWarningBadgeProps) {
  const { warningsWithCounts, totalWarningCount, isLoading } = useBookContentWarnings(bookId);

  if (isLoading || totalWarningCount === 0) return null;

  const topWarnings = warningsWithCounts.slice(0, 3);
  const moreCount = totalWarningCount - 3;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            className={`
              inline-flex items-center justify-center
              w-5 h-5 rounded-full
              bg-amber-500/20 text-amber-600 dark:text-amber-400
              ${className}
            `}
          >
            <AlertTriangle className="h-3 w-3" />
          </div>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-[200px]">
          <p className="text-xs font-medium mb-1">Content warnings:</p>
          <ul className="text-xs space-y-0.5">
            {topWarnings.map((w) => (
              <li key={w.warning_name}>• {w.warning_name}</li>
            ))}
            {moreCount > 0 && (
              <li className="text-muted-foreground">+{moreCount} more</li>
            )}
          </ul>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
